class CosmoFirstDiscovery {
  constructor(section) {
    if (section.dataset.discoveryReady === 'true') return;

    section.dataset.discoveryReady = 'true';
    this.section = section;
    this.media = section.querySelector('[data-discovery-media]');
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.frameRequested = false;
    this.isVisible = false;

    this.onScroll = this.onScroll.bind(this);
    this.updateParallax = this.updateParallax.bind(this);

    if (section.dataset.motion !== 'true' || this.prefersReducedMotion.matches) {
      section.classList.add('is-visible');
      return;
    }

    this.revealObserver = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        this.isVisible = true;
        section.classList.add('is-visible');
        this.onScroll();
        this.revealObserver.disconnect();
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
    );

    this.visibilityObserver = new IntersectionObserver(
      ([entry]) => {
        this.isVisible = entry.isIntersecting;
        if (this.isVisible) this.onScroll();
      },
      { rootMargin: '20% 0px' }
    );

    this.revealObserver.observe(section);
    this.visibilityObserver.observe(section);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onScroll, { passive: true });
  }

  onScroll() {
    if (!this.isVisible || !this.media || this.frameRequested) return;

    this.frameRequested = true;
    window.requestAnimationFrame(this.updateParallax);
  }

  updateParallax() {
    const bounds = this.section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const progress = (viewportHeight - bounds.top) / (viewportHeight + bounds.height);
    const centered = Math.max(-0.5, Math.min(0.5, progress - 0.5));
    const offset = centered * 44;

    this.section.style.setProperty('--discovery-parallax', `${offset.toFixed(2)}px`);
    this.frameRequested = false;
  }

  destroy() {
    this.revealObserver?.disconnect();
    this.visibilityObserver?.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }
}

const initializeCosmoDiscoveries = (root = document) => {
  root.querySelectorAll('[data-cosmo-discovery]').forEach((section) => new CosmoFirstDiscovery(section));
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeCosmoDiscoveries(), { once: true });
} else {
  initializeCosmoDiscoveries();
}

document.addEventListener('shopify:section:load', (event) => initializeCosmoDiscoveries(event.target));
